import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoleComponent } from './components/role/role.component';
import { AuthKeycloakGuard } from './guard/auth.guard';

const routes: Routes = [
    // { path: '', component: RoleComponent },
    { path: '', redirectTo: 'register', pathMatch: 'full' },
    { path: 'register', loadChildren: async () => (await import('./components/register/register.module')).RegisterModule, canActivate: [AuthKeycloakGuard] },
    { path: 'select-your-role', component: RoleComponent },
];
@NgModule({
    imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
    exports: [RouterModule],
})
export class AppRoutingModule { }
